<template>
    <div class="firma-page">
        <vx-card>
            <h4 class="mb-1">
                <i class="feather icon-shield mr-2"></i>
                Firma electrónica de documento
            </h4>
            <p class="text-muted mb-5">
                Genera y descarga el PDF firmado digitalmente con tu certificado .p12.
            </p>

            <div class="vx-row mb-4">
                <div class="vx-col w-full md:w-1/2">
                    <vs-input
                        class="w-full"
                        label="Motivo de la firma (opcional)"
                        v-model="motivo"
                        placeholder="Ej: Aprobación de documento"
                    />
                </div>
            </div>

            <vs-button
                color="success"
                type="relief"
                icon-pack="feather"
                icon="icon-check-circle"
                :disabled="firmando"
                @click="firmar"
            >
                {{ firmando ? 'Generando PDF firmado...' : 'Generar y ver PDF firmado' }}
            </vs-button>

            <!-- Advertencia (cert vencido, TSA fallo, etc.) -->
            <vs-alert v-if="advertencia" color="warning" icon="warning" class="mt-4">
                <strong>Advertencia:</strong> {{ advertencia }}
            </vs-alert>

            <vs-alert v-if="errorMsg" color="danger" icon="error" class="mt-4">
                {{ errorMsg }}
            </vs-alert>

            <!-- Info de firma exitosa con TSA -->
            <div v-if="pdfUrl && !advertencia" class="firma-ok-badge mt-4">
                <i class="feather icon-check-circle mr-1"></i>
                Documento firmado con sello de tiempo (PAdES-T) — válido en FirmaEC
            </div>

            <!-- Visor del PDF firmado -->
            <div v-if="pdfUrl" class="pdf-viewer-box mt-3">
                <div class="pdf-viewer-header">
                    <span><i class="feather icon-file-text mr-1"></i>Documento firmado</span>
                    <a :href="pdfUrl" :download="nombreDescarga" class="download-link">
                        <i class="feather icon-download mr-1"></i>Descargar PDF
                    </a>
                </div>
                <iframe
                    :src="pdfUrl"
                    class="pdf-iframe"
                    type="application/pdf"
                    title="Documento firmado electrónicamente"
                ></iframe>
            </div>
        </vx-card>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            idusuario:      '',
            motivo:         'Firma electrónica Prolipa',
            firmando:       false,
            pdfUrl:         null,
            nombreDescarga: 'documento_firmado.pdf',
            advertencia:    '',
            errorMsg:       '',
        }
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario') || '{}')
        if (usuario.idusuario) {
            this.idusuario = usuario.idusuario
        }
    },
    beforeDestroy() {
        if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) {
            URL.revokeObjectURL(this.pdfUrl)
        }
    },
    methods: {
        firmar() {
            var me = this

            if (!me.idusuario) {
                me.errorMsg = 'No se encontró el usuario en sesión.'
                return
            }

            me.firmando    = true
            me.errorMsg    = ''
            me.advertencia = ''
            me.pdfUrl      = null
            me.$vs.loading({ color: '#059669' })

            axios.post(
                me.$data_url + 'api/firmarHtmlUsuario',
                { idusuario: me.idusuario, motivo: me.motivo },
                { responseType: 'blob' }
            )
            .then(function(response) {
                me.firmando = false
                me.$vs.loading.close()

                var contentType = (response.headers && response.headers['content-type']) || ''

                if (contentType.indexOf('application/pdf') === -1) {
                    var reader = new FileReader()
                    reader.onload = function() {
                        try {
                            var json = JSON.parse(reader.result)
                            me.errorMsg = json.message || 'El servidor no devolvió un PDF válido.'
                        } catch (e) {
                            me.errorMsg = 'El servidor no devolvió un PDF válido.'
                        }
                    }
                    reader.readAsText(response.data)
                    return
                }

                // Leer advertencia del header (cert vencido, TSA no disponible, etc.)
                var advertenciaHeader = (response.headers && response.headers['x-firma-advertencia']) || ''
                if (advertenciaHeader && advertenciaHeader.trim()) {
                    me.advertencia = advertenciaHeader.trim()
                }

                // Leer nombre del firmante para el archivo descargado
                var firmante = (response.headers && response.headers['x-firma-firmante']) || 'usuario'
                var fecha    = new Date().toISOString().slice(0, 10).replace(/-/g, '')
                me.nombreDescarga = 'firmado_' + firmante.replace(/\s+/g, '_') + '_' + fecha + '.pdf'

                var blob   = new Blob([response.data], { type: 'application/pdf' })
                me.pdfUrl  = URL.createObjectURL(blob)

                me.$vs.notify({
                    text: me.advertencia
                        ? 'PDF firmado (revisar advertencia)'
                        : 'PDF firmado con sello de tiempo correctamente',
                    color: me.advertencia ? 'warning' : 'success',
                    iconPack: 'feather',
                    icon: me.advertencia ? 'icon-alert-triangle' : 'icon-check',
                })
            })
            .catch(function(error) {
                me.firmando = false
                me.$vs.loading.close()

                if (error.response && error.response.data instanceof Blob) {
                    var reader = new FileReader()
                    reader.onload = function() {
                        try {
                            var json = JSON.parse(reader.result)
                            me.errorMsg = json.message || 'Error al firmar el documento.'
                        } catch (e) {
                            me.errorMsg = 'Error al firmar el documento.'
                        }
                    }
                    reader.readAsText(error.response.data)
                } else {
                    me.errorMsg = (error.response && error.response.data && error.response.data.message)
                        ? error.response.data.message
                        : 'Error al firmar el documento.'
                }
            })
        },
    },
}
</script>

<style scoped>
.firma-page {
    max-width: 960px;
    margin: 0 auto;
    padding: 16px;
}

.text-muted {
    color: #64748b;
    font-size: 13px;
}

.firma-ok-badge {
    display: inline-flex;
    align-items: center;
    background: #ecfdf5;
    border: 1px solid #6ee7b7;
    color: #065f46;
    border-radius: 8px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 600;
}

.pdf-viewer-box {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
}

.pdf-viewer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f1f5f9;
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    border-bottom: 1px solid #e2e8f0;
}

.download-link {
    color: #059669;
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
}

.download-link:hover {
    text-decoration: underline;
}

.pdf-iframe {
    width: 100%;
    height: 720px;
    border: none;
    display: block;
}
</style>
